
/**
 * Credit https://blog.hackages.io/conditionally-wrap-an-element-in-react-a8b9a47fab2
 * 
 * This is a functional way of wrapping some content in desired wrapper
 */
export const ConditionalWrapper = ({ condition, wrapper, children }) => 
  condition ? wrapper(children) : children;